/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

export const taskList = styled.ul({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  maxWidth: '480px',
});
